import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0); /* Initial and final position */
  }
  40% {
    transform: translateY(-20px); /* Bounce up */
  }
  60% {
    transform: translateY(-10px); /* Bounce down */
  }
`;

export const EmployerBrandingWrapper = styled.div`
  display: flex;
  margin-top: 97px;
  align-items: center;
  flex-direction: column;
`;

export const Header = styled.div`
  font-family: "Rubik", sans-serif;
  font-size: 38px;
  font-style: normal;
  font-weight: 500;
  line-height: 47px;
  letter-spacing: -0.76px;
`;

export const SubHeader = styled.span`
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  color: #4a4a51;
  line-height: 28px;
  margin-top: 10px;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 59px;
  gap: 30px;
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 216px;
  height: 216px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #dfe8f2;
  cursor: pointer;
  transition: border-color 0.3s ease-in-out, opacity 0.3s ease-in-out;
  :hover {
    > img {
      animation: ${bounce} 1s;
    }
  }
`;

export const Image = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 11px;
`;

export const Description = styled.span`
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.36px;
`;

export const SubDescription = styled.span`
  color: #95959e;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-top: 2px;
`;

export const NewBudget = styled.div`
  position: absolute;
  border-radius: 18px;
  background: #1d22ff;
  top: 13px;
  right: 13px;
  padding: 2px 5px;
  color: white;
  font-size: 9px;
  font-weight: bold;
`;

export const NextButton = styled.button`
  width: 257px;
  background-color: #1d22ff;
  display: flex;
  justify-content: center;
  color: #1e22ff;
  border: none;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  border-radius: 4px;
  align-items: center;
  height: 42px;
  color: #fff;
  margin-top: 56px;
  :hover {
    background-color: #0003c2;
  }
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 35px;
  > input {
    cursor: pointer;
  }
  > label {
    cursor: pointer;
  }
`;
